import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-digital-audio';
export var ID = 'icon-digital-audio';
/* eslint-disable max-len */

export var SVGDigitalAudio = function SVGDigitalAudio() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M13,0.5 L13,11.5 L12.9862678,11.5 C12.8619067,12.6249876 11.9081384,13.5 10.75,13.5 C9.50735931,13.5 8.5,12.4926407 8.5,11.25 C8.5,10.0073593 9.50735931,9 10.75,9 C10.8345023,9 10.9179165,9.00465833 11,9.01373219 L11,3.97777785 L6,5.42222224 L6,13.5 L5.98626781,13.5 C5.86190673,14.6249876 4.90813841,15.5 3.75,15.5 C2.50735931,15.5 1.5,14.4926407 1.5,13.25 C1.5,12.0073593 2.50735931,11 3.75,11 C3.83450227,11 3.91791654,11.0046583 4,11.0137322 L4,3 L13,0.5 Z"
  }));
};
/* eslint-disable max-len */

var DigitalAudio = function DigitalAudio(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGDigitalAudio
  });
};

DigitalAudio.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default DigitalAudio;